<div class="auth-page">
  <div class="auth-card">
    <h1 class="auth-heading">Confirm Email</h1>
    <p class="auth-subtitle">Confirming that the email belongs to your account.</p>

    <div class="flex flex-col gap-4">
      <button pButton pRipple label="OK" class="w-full" (click)="logout()" [disabled]="working"
        [loading]="working"></button>

      @if (error) {
        <p class="text-red-500 text-center mt-3 mb-0">{{error}}</p>
      }
      @if (success) {
        <p class="text-green-500 text-center mt-3 mb-0">{{success}}</p>
      }
    </div>

    <div class="auth-divider mt-6 mb-4">or</div>

    <p class="text-center text-sm text-gray-600 mb-0">
      A problem? <a routerLink="/auth/contact-us" class="text-primary font-medium hover:underline">Click here</a> and let
      us help you.
    </p>
  </div>
</div>
